import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AppRouteService {
	site = 'site';

	admin = 'admin';
	roles = 'role-management';
	users = 'user-management';
	steamCosts = 'calculation-settings';
	siteSettings = 'site-settings';

	list = 'list';
	map = 'map';
	leak = 'leak';
	import = 'import';

	constructor() {}

	getListRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.list}`;
		return route;
	}

	getNewLeakRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.list}/leak`;
		return route;
	}

	getExistingLeakRoute(siteId: string, leakId: string) {
		let route = `${this.site}/${siteId}/${this.list}/${this.leak}/${leakId}`;
		return route;
	}

	getImportRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.list}/${this.import}`;
		return route;
	}

	getAdminRolesRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.admin}/${this.roles}`;
		return route;
	}

	getAdminUsersRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.admin}/${this.users}`;
		return route;
	}

	getAdminSteamCostsRoute(siteId: string) {
		let route = `${this.site}/${siteId}/${this.admin}/${this.steamCosts}`;
		return route;
	}

	getAdminSiteSettingsRoute(siteId: string, siteSetting: string) {
		let route = `${this.site}/${siteId}/${this.admin}/${this.siteSettings}/${siteSetting}`;
		return route;
	}
}
